export function br2nl (str, replaceMode) {
  const replaceStr = (replaceMode) ? '\n' : ''
  // Includes <br>, <BR>, <br />, </br>
  return str.replace(/<\s*\/?br\s*[/]?>/gi, replaceStr)
}
